import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const NotFound = lazyRouteComponent(() => import('../components/common/not-found'))

// v1 splat/catch-all uses `$` (beta used `/*`); matches any unmatched path.
export const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: NotFound,
  path: '$',
})
